/**
 * 系统管理模块英文映射（第 2 组：UserList/TenantList/Depart/Dict/Permission 等及其 modules 弹窗）
 * 中文原文 → 英文 扁平映射
 */
export default {
  // 通用
  '确定': 'OK',
  '取消': 'Cancel',
  '关闭': 'Close',
  '提示': 'Notice',
  '查询': 'Query',
  '重置': 'Reset',
  '编辑': 'Edit',
  '删除': 'Delete',
  '新增': 'Add',
  '详情': 'Details',
  '更多': 'More',
  '批量操作': 'Batch Operations',
  '清空': 'Clear',
  '操作': 'Action',
  '创建时间': 'Created At',
  '是': 'Yes',
  '否': 'No',
  '确定删除吗?': 'Are you sure you want to delete?',
  '已选择 {count} 项': '{count} items selected',
  '查看': 'View',
  '添加': 'Add',
  '保存': 'Save',
  '导出': 'Export',
  '下载': 'Download',
  '收起': 'Collapse',
  '展开': 'Expand',
  '状态': 'Status',
  '描述': 'Description',
  '备注': 'Remark',
  '排序': 'Sort Order',
  '地址': 'Address',
  '传真': 'Fax',
  '请输入传真': 'Please enter fax',
  '电话': 'Phone',
  '请输入电话': 'Please enter phone number',
  '请输入地址': 'Please enter address',
  '手机': 'Mobile',
  '手机号': 'Mobile Phone',
  '手机号码': 'Mobile Phone',
  '姓名': 'Name',
  '账号': 'Account',
  '性别': 'Gender',
  '男': 'Male',
  '男性': 'Male',
  '女性': 'Female',
  '生日': 'Birthday',
  '头像': 'Avatar',
  '标题': 'Title',
  '名称': 'Name',
  '无': 'None',
  '无图片': 'No Image',
  '无文件': 'No File',
  '开始时间': 'Start Time',
  '结束时间': 'End Time',
  '请选择': 'Please select',
  '请选择一条记录！': 'Please select a record!',
  '保存成功!': 'Saved successfully!',
  '删除成功!': 'Deleted successfully!',
  '删除失败!': 'Failed to delete!',
  '确认操作': 'Confirm',
  '确认删除': 'Confirm Deletion',
  '确认取消': 'Confirm Unlinking',
  // 树操作
  '树操作': 'Tree Actions',
  '父子关联': 'Parent-Child Link',
  '取消关联': 'Unlink',
  '取消全选': 'Uncheck All',
  '全部勾选': 'Check All',
  '展开所有': 'Expand All',
  '合并所有': 'Collapse All',
  // 部门/机构
  '部门': 'Department',
  '上级部门': 'Parent Department',
  '负责部门': 'Departments in Charge',
  '机构名称': 'Organization Name',
  '机构类型': 'Organization Type',
  '机构编码': 'Organization Code',
  '公司': 'Company',
  '岗位': 'Post',
  '基本信息': 'Basic Information',
  '部门权限': 'Department Permissions',
  '用户编号': 'Customer No.',
  '当前选择：': 'Currently selected:',
  '取消选择': 'Deselect',
  '请输入部门名称': 'Please enter department name',
  '请输入部门角色': 'Please enter department role',
  '请选择上级部门': 'Please select the parent department',
  '添加公司': 'Add Company',
  '请输入机构/部门名称': 'Please enter the organization/department name',
  '请输入机构/部门名称!': 'Please enter the organization/department name!',
  '请输入机构编码': 'Please enter organization code',
  '请输入机构编码!': 'Please enter the organization code!',
  '请输入机构类型!': 'Please enter the organization type!',
  '请选择机构类型': 'Please select organization type',
  '请输入手机号': 'Please enter mobile phone number',
  '请输入应用ID': 'Please enter app ID',
  '应用ID': 'App ID',
  '请输入appId!': 'Please enter the appId!',
  '该应用ID已被绑定，请验证后重新输入!': 'This App ID is already bound, please verify and re-enter!',
  '请先选择一个部门!': 'Please select a department first!',
  '请先点击选中上级部门！': 'Please select a parent department first!',
  '请点击选择要修改部门!': 'Please click to select the department to modify!',
  '请点击选择一个部门!': 'Please click to select a department!',
  '请选择一个部门!': 'Please select a department!',
  '确定要删除所选中的 {count} 条数据，以及子节点数据吗?': 'Are you sure to delete the selected {count} records and their child nodes?',
  '确定要删除此部门以及子节点数据吗?': 'Are you sure to delete this department and its child nodes?',
  '您的手机号码格式不正确!': 'Invalid mobile phone number format!',
  '部门搜索': 'Department Search',
  '部门权限配置': 'Department Permission Configuration',
  '所拥有的权限': 'Owned Permissions',
  '所拥有的部门权限': 'Owned Department Permissions',
  '无可配置部门权限!': 'No configurable department permissions!',
  '仅保存': 'Save Only',
  '保存并关闭': 'Save and Close',
  '确定放弃编辑？': 'Are you sure to discard the changes?',
  '部门角色名称': 'Department Role Name',
  '部门角色编码': 'Department Role Code',
  '新建部门角色': 'New Department Role',
  '部门角色分配': 'Department Role Assignment',
  '部门角色权限配置': 'Department Role Permission Configuration',
  '分配部门角色': 'Assign Department Roles',
  '无可配置角色!': 'No configurable roles!',
  '未选中任何部门，无法取消部门与用户的关联!': 'No department selected; cannot unlink users from the department!',
  '是否取消用户与选中部门的关联?': 'Unlink the users from the selected department?',
  '删除用户与选中部门关系成功！': 'Successfully removed the relation between the users and the selected department!',
  '确定取消与选中部门关联吗?': 'Are you sure to unlink from the selected department?',
  '授权': 'Authorize',
  // 用户
  '用户账号': 'User Account',
  '用户名称': 'Customer Name',
  '用户姓名': 'Customer Name',
  '用户信息': 'Customer Info',
  '用户详情': 'Customer Details',
  '用户状态': 'Customer Status',
  '用户编号生成': 'Customer No. Generation',
  '用户编号前缀': 'Customer No. Prefix',
  '用户编号长度': 'Customer No. Length',
  '当前用户编号': 'Current Customer No.',
  '用户编号说明': 'Customer No. Instructions',
  '1.用户编号格式为用户编号前缀+当前用户编号；': '1. The customer No. format is the customer No. prefix plus the current customer No.;',
  '2.当前用户编号长度不够设置的编号长度时自动在编号前补0；': '2. Zeros are automatically padded before the number when the current customer No. is shorter than the set length;',
  '3.例如：用户编号前缀为MX,用户编号长度为8，当前用户编号为1；那么当选中“用户编号自动生成”功能后，系统生成的用户编号为MX00000001；': '3. For example: with the customer No. prefix MX, length 8 and current customer No. 1, after enabling automatic generation the generated customer No. is MX00000001;',
  '用户编号只能输入数字': 'The customer No. can only contain digits',
  '用户编号长度超限': 'Customer No. length exceeded',
  '请选择用户编号生成规则': 'Please select the customer No. generation rule',
  '请选择用户编号长度': 'Please select the customer No. length',
  '请输入用户编号前缀': 'Please enter the customer No. prefix',
  '请输入当前用户编号': 'Please enter the current customer No.',
  '手动输入': 'Manual Input',
  '自动生成': 'Auto Generate',
  '请选择生成方式': 'Select generation method',
  '添加用户': 'Add User',
  '新建用户': 'New User',
  '添加已有用户': 'Add Existing User',
  '输入账号模糊查询': 'Enter account to search',
  '请输入账号': 'Please enter the account',
  '请输入用户姓名': 'Please enter customer name',
  '请输入用户账号': 'Please enter the user account',
  '请选择性别': 'Select gender',
  '请输入手机号码查询': 'Enter mobile phone number to search',
  '正常': 'Normal',
  '冻结': 'Freeze',
  '解冻': 'Unfreeze',
  '确定冻结吗?': 'Are you sure to freeze?',
  '确定解冻吗?': 'Are you sure to unfreeze?',
  '回收站': 'Recycle Bin',
  '区域授权': 'Area Authorization',
  '修改密码': 'Change Password',
  '重新设定密码': 'Reset Password',
  '登录密码': 'Login Password',
  '确认密码': 'Confirm Password',
  '请输入登录密码': 'Please enter the login password',
  '请重新输入登录密码': 'Please re-enter the login password',
  '请重新输入登录密码!': 'Please re-enter the login password!',
  '密码由8位数字、大小写字母和特殊符号组成!': 'Password must be at least 8 characters with digits, upper/lowercase letters and special characters!',
  '两次输入的密码不一样！': 'The two passwords do not match!',
  '用户代理人设置': 'User Agent Settings',
  '该用户已被巡检关联，是否删除该用户？': 'This user is linked to inspections. Delete this user anyway?',
  '是否{action}选中账号?': '{action} the selected accounts?',
  '管理员账号不允许此操作,请重新选择！': 'This operation is not allowed for the admin account, please select again!',
  '管理员账号不允许此操作！': 'This operation is not allowed for the admin account!',
  '工号': 'Job Number',
  '请输入工号查询': 'Enter job number to search',
  '公司邮箱': 'Company Email',
  '职务': 'Position',
  '请输入姓名查询': 'Enter name to search',
  // 用户/账号异常
  '异常账户': 'Abnormal Account',
  '异常类型': 'Abnormal Type',
  '登录ip异常': 'Abnormal Login IP',
  '账户异常': 'Abnormal Account',
  '异常客户端操作系统': 'Abnormal Client OS',
  '异常ip': 'Abnormal IP',
  '异常城市': 'Abnormal City',
  '异常浏览器': 'Abnormal Browser',
  '异常描述': 'Abnormal Description',
  '请选择是否查看': 'Select whether viewed',
  // 租户
  '租户名称': 'Tenant Name',
  '租户编号': 'Tenant No.',
  // 通告
  '发布人': 'Publisher',
  '发布时间': 'Publish Time',
  '请输入发布人': 'Please enter publisher',
  '请输入标题': 'Please enter the title',
  '全部标注已读': 'Mark All as Read',
  '是否全部标注已读?': 'Mark all as read?',
  '消息类型': 'Message Type',
  '通知公告': 'Notice & Announcement',
  '系统消息': 'System Message',
  '优先级': 'Priority',
  '低': 'Low',
  '中': 'Medium',
  '高': 'High',
  '阅读状态': 'Read Status',
  '未读': 'Unread',
  '已读': 'Read',
  // 数据日志/对比
  '数据对比窗口': 'Data Comparison',
  '数据比较': 'Data Comparison',
  '数据库表名': 'Database Table Name',
  '请输入数据库表名': 'Please enter the database table name',
  '数据ID': 'Data ID',
  '请输入数据ID': 'Please enter the data ID',
  '版本号1': 'Version 1',
  '版本号2': 'Version 2',
  '请选择版本号': 'Select version',
  '版本:': 'Version: ',
  '字段名': 'Field Name',
  // 数据规则
  '数据规则': 'Data Rule',
  '数据规则/按钮权限配置': 'Data Rule/Button Permission Configuration',
  '无配置信息!': 'No configuration!',
  '点击保存': 'Click to Save',
  '请注意，现未勾选任何数据权限!': 'Note: no data permission is checked!',
  '规则名称': 'Rule Name',
  '规则字段': 'Rule Field',
  '条件规则': 'Condition Rule',
  '规则值': 'Rule Value',
  '请输入规则名称': 'Please enter rule name',
  '请输入规则名称!': 'Please enter the rule name!',
  '请输入规则字段': 'Please enter the rule field',
  '请输入规则值': 'Please enter rule value',
  '请输入规则值!': 'Please enter the rule value!',
  '请输入条件规则': 'Please enter the condition rule',
  '请选择条件!': 'Please select the condition!',
  '有效': 'Valid',
  '无效': 'Invalid',
  // 字典
  '字典名称': 'Dictionary Name',
  '字典编码': 'Dictionary Code',
  '请输入字典名称': 'Please enter dictionary name',
  '请输入字典名称!': 'Please enter the dictionary name!',
  '请输入字典编码': 'Please enter dictionary code',
  '请输入字典编码!': 'Please enter the dictionary code!',
  '请输入名称': 'Please enter name',
  '请输入名称!': 'Please enter the name!',
  '数据值': 'Data Value',
  '请输入数据值': 'Please enter the data value',
  '请输入数据值!': 'Please enter the data value!',
  '排序值': 'Sort Value',
  '值越小越靠前，支持小数': 'Smaller values come first; decimals are supported',
  '是否启用': 'Enabled',
  '启用': 'Enabled',
  '禁用': 'Disabled',
  // 文件管理
  '文件名称': 'File Name',
  '文件描述': 'File Description',
  '附件': 'Attachment',
  '请输入文件名称': 'Please enter file name',
  '请输入文件描述': 'Please enter the file description',
  '请选择文件': 'Please select a file',
  // 菜单/权限
  '菜单类型': 'Menu Type',
  '一级菜单': 'Top-level Menu',
  '子菜单': 'Sub Menu',
  '按钮/权限': 'Button/Permission',
  '菜单名称': 'Menu Name',
  '上级菜单': 'Parent Menu',
  '请选择上级菜单': 'Please select the parent menu',
  '请选择父级菜单': 'Please select the parent menu',
  '菜单路径': 'Menu Path',
  '前端组件': 'Front-end Component',
  '组件名称': 'Component Name',
  '默认跳转地址': 'Default Redirect Address',
  '授权标识': 'Authorization Identifier',
  '授权标识已存在!': 'The authorization identifier already exists!',
  '授权策略': 'Authorization Policy',
  '菜单图标': 'Menu Icon',
  '是否路由菜单': 'Route Menu',
  '隐藏路由': 'Hidden Route',
  '是否缓存路由': 'Cache Route',
  '聚合路由': 'Aggregate Route',
  '打开方式': 'Open Mode',
  '内部': 'Internal',
  '外部': 'External',
  '点击选择图标': 'Click to select an icon',
  '多个用逗号分隔, 如: user:list,user:create': 'Multiple values separated by commas, e.g.: user:list,user:create',
  '请输入菜单名称': 'Please enter the menu name',
  '请输入菜单标题!': 'Please enter the menu title!',
  '请输入菜单路径': 'Please enter the menu path',
  '请输入菜单路径!': 'Please enter the menu path!',
  '请输入菜单排序': 'Please enter the menu sort order',
  '请输入前端组件': 'Please enter the front-end component',
  '请输入前端组件!': 'Please enter the front-end component!',
  '请输入前端组件名称': 'Please enter the front-end component name',
  '请输入路由参数 redirect': 'Please enter the route parameter redirect',
  '请输入授权标识!': 'Please enter the authorization identifier!',
  '请输入授权策略!': 'Please enter the authorization policy!',
  '请选择授权策略': 'Select authorization policy',
  '请选择状态': 'Select status',
  '请输入正整数!': 'Please enter a positive integer!',
  '请检查你填的类型以及信息是否正确！': 'Please check whether the type and information you filled in are correct!',
  // 通用补充
  '请设置url.list属性!': 'Please set the url.list property!',
  '请设置url.delete属性!': 'Please configure the url.delete property!',
  '请设置url.deleteBatch属性!': 'Please configure the url.deleteBatch property!',
  '输入部门名称查询...': 'Enter department name to search...',

  // ---- 系统账号（与用水客户区分） ----
  '账号名称': 'Account Name',
  '账号姓名': 'Account Holder Name',
  '账号状态': 'Account Status',
  '账号列表': 'Account List',
  '账号详情': 'Account Details',
  '账号信息': 'Account Information',
  '新增账号': 'Add Account',
  '编辑账号': 'Edit Account',
  '选择账号': 'Select Account',
  '已有账号': 'Existing Accounts',
  '冻结账号': 'Freeze Account',
  '解冻账号': 'Unfreeze Account',
  '账号回收站': 'Account Recycle Bin',
  '授权账号': 'Authorize Accounts',
  '登录账号': 'Login Account',
  '新建账号': 'Add Account',
  '请输入登录账号!': 'Please enter the login account!',
  '请输入账号名称!': 'Please enter the account name!'
}
